
<div class="content"> 
<div class="section-tab">
    <div class="row-header">
        <div class="col-header">ID</div>
        <div class="col-header">Service type</div>
        <div class="col-header">Status</div>
        <div class="col-header">Planned date</div>
    </div>
    <div class="row" *ngFor="let recommendedService of recommendedServices">
        <div class="col">{{ recommendedService.id }}</div>
        <div class="col">{{recommendedService.type?.description}}</div>
        <div class="col">{{ recommendedService.status }}</div>
        <div class="col">{{ recommendedService.plannedDate | date }}</div>
    </div>
</div>
</div>
